module.exports = __webpack_public_path__ + "img/default-user.06dc4326.png";